<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择建议人"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="rSSuggestions">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="建议人">
            <el-input v-model.trim="filter.proposer" clearable/>
          </vm-search>
          <vm-search label="建议人工号">
            <el-input v-model.trim="filter.proposerNo" clearable/>
          </vm-search>
          <vm-search label="建议人部门">
            <el-input v-model.trim="filter.department" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="proposer" align="center" label="建议人"/>
      <el-table-column prop="proposerNo" align="center" label="建议人工号"/>
      <el-table-column prop="department" align="center" label="建议人部门"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";


  export default {
    name:"EmployeeSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          proposer: "",
          proposerNo: "",
          department: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
